import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import { Wifi, WifiOff } from "@mui/icons-material";

const OnlineDetail1Widget = ({ widget, onValueUpdate }) => {
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      if (widget.items.$w1.value === "online") {
        setIsOnline(true);
      } else {
        setIsOnline(false);
      }
    }
  }, [widget]);

  const getStatusText = () => {
    return isOnline ? "Online" : "Offline";
  };

  const getStatusIcon = () => {
    return isOnline ? (
      <Wifi style={{ fontSize: "1.5rem", color: "white" }} />
    ) : (
      <WifiOff style={{ fontSize: "1.5rem", color: "white" }} />
    );
  };

  const getStatusColor = () => {
    return isOnline ? "#4CAF50" : "#F44336";
  };

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Online Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-300"
        style={{
          height: "60px",
          backgroundColor: getStatusColor(),
        }}
      >
        <Typography className="text-white font-bold">
          {getStatusText()}
        </Typography>
        <div className="h-10 aspect-square flex items-center justify-center flex-shrink-0">
          {getStatusIcon()}
        </div>
      </div>

      {/* Connection Status Info */}
      <div
        className="flex flex-col gap-2 p-4 rounded-2xl"
        style={{
          backgroundColor: "hsl(var(--card))",
        }}
      >
        <Typography className="font-bold">Connection Status</Typography>

        <div className="flex justify-between items-center">
          <Typography
            className="text-sm"
            style={{ color: "hsl(var(--muted-foreground))" }}
          >
            Device Status:
          </Typography>
          <Typography
            className="font-bold text-sm"
            style={{
              color: isOnline ? "#4caf50" : "hsl(var(--destructive))",
            }}
          >
            {getStatusText()}
          </Typography>
        </div>

        <div className="flex justify-between items-center">
          <Typography
            className="text-sm"
            style={{ color: "hsl(var(--muted-foreground))" }}
          >
            Connection:
          </Typography>
          <div className="flex items-center gap-2">
            {isOnline ? (
              <Wifi style={{ fontSize: "1rem", color: "#4caf50" }} />
            ) : (
              <WifiOff
                style={{ fontSize: "1rem", color: "hsl(var(--destructive))" }}
              />
            )}
            <Typography
              className="text-sm"
              style={{
                color: isOnline ? "#4caf50" : "hsl(var(--destructive))",
              }}
            >
              {isOnline ? "Connected" : "Disconnected"}
            </Typography>
          </div>
        </div>

        <Typography
          className="text-xs italic mt-2"
          style={{ color: "hsl(var(--muted-foreground))" }}
        >
          {isOnline
            ? "Device is connected and communicating normally"
            : "Device is offline or not responding"}
        </Typography>
      </div>
    </div>
  );
};

export default OnlineDetail1Widget;
